<template>
  <div class="text-left">
    <p>Flowneat （ 以下稱「Flowneat」或「本網站」） 係由「普魯士國際有限公司」（ 以下稱「本公司」） 所經營，為保護您的個人資料並讓您能夠更安心的使用本網站所提供的各項服務，於使用本網站前，請您詳細閱讀本「隱私權政策」，並確實遵守下述條款。</p>

    <p>當您使用本網站時，即視同您瞭解及同意本網站依據「隱私權政策」蒐集、處理與利用您的個人資料。如果您不能夠同意隱私權政策，請不要使用相關服務。您對本隱私權政策中說明的處理程序，如有任何看法與建議， 請不吝與本公司聯繫。
    </p>
    <h4 class="text-center">一、適用範圍</h4>
    <p>此政策適用於您在本網站活動時，所涉及的資料蒐集、處理、利用與保護，包括但不限於 Flowneat 處理在您使用網站服務時所蒐集到的身份識別資料、Flowneat 與商業伙伴合作時分享您的身份識別資料等。原則上您進入本網站時，並不需要輸入個人資料，但當您要註冊為 Flowneat 之會員使用相關服務時，Flowneat 將會請您登錄個人資料，截至您通知 Flowneat 停止蒐集、處理、利用您的個人資料前，Flowneat 將依您提供個人資料的目的，處理、利用您的各類資料。Flowneat 將會以符合法規資訊安全的標準，於您使用之服務之相關目的範圍內加以處理、利用。Flowneat 再次提醒您，若您不同意上述內容，您應該立刻停止使用本網站提供之服務。
    </p>
    <p>本網站上可能包含其他合作的外部網站資訊或其網頁連結，這些外部網站也可能會蒐集您的個人資料，但不論其內容或其隱私權政策，皆與本網站無關，請您務必瞭解並審慎決定是否要提供您的個人資料。本網站對任何外部網站的行為，均不負任何擔保或連帶責任。
    </p>
    <h4 class="text-center">二、Cookie之使用</h4>
    <p>為了提供您最佳的服務，本網站會在您的電腦中放置並取用我們的Cookie，若您不願接受Cookie的寫入，您可在您使用的瀏覽器功能項中設定隱私權等級為高，即可拒絕Cookie的寫入，但可能會導至網站某些功能無法正常執行 。</p>
    <h4 class="text-center">三、個人資料的蒐集、處理及利用方式</h4>
    <p>本公司取得您個人資料，係用於客戶管理、會員管理、資訊與資料庫管理、贈品兌換活動、會員登錄及驗證、提供金流服務、付款、請款、廣告行銷、服務訊息、特別活動或新產品通知、改進為您提供的網頁內容、完成您對某項產品的要求等特定目的。本公司將依您提供個人資料之目的，以符合法令之自動化及人工方式處理、利用您的各類資料，於取得您的書面同意前，或法律另有明文規定外，本公司絕不會將您的個人資料進行特定目的外之利用。
    </p>
    <p>使用 Flowneat 服務時，我們會自動記錄來自您的裝置、裝置軟體以及您使用服務時的資訊。此資訊可能包括裝置的網際網路協定（Internet Protocol，IP）位址、使用時間、瀏覽器類型、開啟我們網站前您的所在網頁、您在我們網站中瀏覽及點選資料紀錄、與您的裝置連結的識別號碼、與交易相關的日期和時間戳記、系統組態設定資訊及其他您與 Flowneat 服務的互動情形。
    </p>
    <p>
      為提供您個人化服務、統計瀏覽人數及分析瀏覽模式、了解網頁瀏覽的情況、方便您參與個人化的互動活動以及作為本網站改善服務的參考，我們也會使用「Cookie」（一種我們會傳輸至您裝置中的小型資料檔案） 來收集資訊並改善我們的服務。
    </p>
    <p>您可自由選擇是否提供您的個人資料，但當您不同意提供時，您將無法享有 Flowneat 所提供之全部或特定會員服務。
    </p>
    <h4 class="text-center">四、第三方個人資料的蒐集、處理及利用方式</h4>
    <p>第三方個人資料之定義：當您使用本網站之串接服務，串接第三方所提供服務，例如您的電子郵件帳號（您要求我們匯出您的通訊錄）、線上行事曆帳號（您要求我們為您同步更新行事曆）及其他存取該第三方所提供服務之必要資料。
    </p>
    <p>本公司取得您第三方個人資料，係用於客戶管理、會員管理、資訊與資料庫管理、贈品兌換活動、會員登錄及驗證、提供金流服務、付款、請款、廣告行銷、服務訊息、特別活動或新產品通知、改進為您提供的網頁內容、完成您對某項產品的要求等特定目的。本公司將依您提供個人資料之目的，以符合法令之自動化及人工方式處理、利用您的各類資料，於取得您的書面同意前，或法律另有明文規定外，本公司絕不會將您的個人資料進行特定目的外之利用。
    </p>
    <h4 class="text-center">五、同意個人資料與第三方個人資料之蒐集、處理、利用或國際傳輸</h4>
    <p>您了解並同意本公司依本「網站使用條款暨隱私權政策」及相關法規，蒐集、處理、利用或國際傳輸您所提供的個人資料。
    </p>
    <h4 class="text-center">六、個人資料與第三方個人資料分享及公開</h4>
    <p>除下列情形及本隱私權政策、Flowneat 會員服務條款、Flowneat 付費會員服務條款有記載之事由外， Flowneat不會任意提供、出售、交換、轉讓或揭露任何您的個人資料予第三人。
    </p>
    <p>
      <ol>
        <li>經由您書面同意。</li>
        <li>法律明文規定。</li>
        <li>為免除您生命、身體、自由或財產上之危險。</li>
        <li>與公務機關或學術研究機構合作，基於公共利益為統計或學術研究而有必要，且資料經過提供者處理或蒐集著依其揭露方式無從識別特定之當事人。</li>
        <li>當您在網站的行為，違反服務條款或可能損害或妨礙網站與其他使用者權益或導致任何人遭受損害時，經網站管理單位研析揭露您的個人資料是為了辨識、聯絡或採取法律行動所必要者。</li>
        <li>有利於您的權益。</li>
        <li>本公司在與其他第三人合作提供服務或舉辦活動時，與該第三人共用、傳遞您的資料，才能夠提供您要求的產品或服務。惟Flowneat會於各該活動頁面明確告知您的個人資料將因使用該服務或參與該活動而提供予合作之第三人，您可以自由選擇是否接受這項特定服務或優惠。如您選擇使用該服務或參與該活動，即表示您瞭解並同意將該個人資料為各該服務或活動之目的提供予合作之第三人。
        </li>
        <li>本網站委託廠商協助蒐集、處理或利用您的個人資料時，將對委外廠商或個人善盡監督管理之責。</li>
        <li>基於善意相信揭露為維護和改進產品、服務而用於管理或其他目的。
        </li>
        <li>本公司被其他公司收購或合併，我們有權利將您的個人資料移轉給該公司。如果發生這種情況，本公司會在您的個人資料被移轉且將適用不同的隱私權政策前通知您。
        </li>
      </ol>
    </p>
    <h4 class="text-center">七、您對個人資料之權利</h4>
    <p>在不違反相關法律的情況下，於本公司確認該個人資料為您本人所有後，您可將您的需求郵寄至本公司/本網站的電子郵件信箱 （service@playplus.com.tw），以行使下列之權利：
    </p>
    <p>（1）查詢、閱覽、補充或更正您的個人資料。
      （2）停止蒐集、處理或利用您的個人資料。
      （3）刪除您的個人資料。
      （4）製給您個人資料的複製本。
      （5）停止寄發給您本網站相關廣告及行銷活動。
    </p>
    <h4 class="text-center">八、客戶資料</h4>
    <p>您可能於本網站中輸入資料，以使用 Flowneat 客戶管理、工作管理、商機管理等服務 （ 以下稱此類資料為「客戶資料」）。Flowneat 不會主動檢閱、共用、散佈或參考任何此類「客戶資料」，但依法律所要求之情況則不在此限。Flowneat 僅能基於提供服務、預防或解決服務或技術問題之目的、應客戶要求處理客戶支援問題，或法律規定之必要狀況，來存取「客戶資料」。
    </p>
    <h4 class="text-center">九、安全性</h4>
    <p>為保障您的隱私及安全，本公司將依相關法律規定，採取適當的技術性和組織性等安全措施，保護您所提供的個人資料或客戶資料，並請您妥善保管您的密碼及∕或任何個人資料。但請注意，儘管本公司會盡力保護您提供的個人資料或客戶資料，仍無法保證該等資料百分之百不會遭受第三人之非法攔截、傳送或盜駭。
      　</p>
    <p>　如您與他人共用之電腦、或使用公用電腦時，瀏覽完本網站及使用相關服務後，請登出並關閉瀏覽器視窗並清除瀏覽資訊，防止他人讀取您提供的個人資料或客戶資料，以保護該等資料。
      　</p>
    <p>　在您登入Flowneat帳戶時，本網站使用通行標準的 SSL 保全系統，保障資料傳送的安全。
    </p>

    <h4 class="text-center">十、資料之保護</h4>
    <p>本網站主機均設有防火牆、防毒系統等相關的各項資訊安全設備及必要的安全防護措施，加以保護網站及您的個人資料採用嚴格的保護措施，只由經過授權的人員才能接觸您的個人資料，相關處理人員皆簽有保密合約，如有違反保密義務者，將會受到相關的法律處分。</p>
    <p>如因業務需要有必要委託其他單位提供服務時，本網站亦會嚴格要求其遵守保密義務，並且採取必要檢查程序以確定其將確實遵守。</p>

    <h4 class="text-center">十一、修改本隱私權政策條款的權利</h4>
    <p>　　本公司有權隨時視實際情形修訂本條款，本條款有重大變更時，本公司將張貼公告，您有義務隨時注意本條款有無更新或修訂。如您不同意所變更之內容，得隨時選擇退出相關服務，並請您立即停用 Flowneat 之服務，如您繼續使 Flowneat，即表示您同意本條款變更之內容。
    </p>
  </div>
</template>
<script>
export default {
  name: 'privacyTerm',
  data() {
    return {

    }
  },
  created() {

  },
  methods: {

  }
}

</script>



// WEBPACK FOOTER //
// PrivacyTerm.vue?2479e3af